import type { audit as en } from '@/i18n/locales/en/audit';
import type { Translation } from '@/i18n/types';

export const audit: Translation<typeof en> = {
  page: {
    title: 'Αρχείο ελέγχου',
    scopedLead:
      'Βλέπετε τις επιτρεπόμενες ενέργειες για τις δικές σας εταιρείες· οι απαντήσεις συγκατάθεσης και οι συνδέσεις ταυτότητας δεν περιλαμβάνονται ποτέ.',
    actionFilter: 'Φιλτράρισμα κατά ενέργεια',
    actionPlaceholder: 'ενέργεια, π.χ. department.visibility.update',
    scopeFilter: 'Φιλτράρισμα κατά πεδίο εφαρμογής',
    scopePlaceholder: 'id πεδίου εφαρμογής',
    filter: 'Φιλτράρισμα',
    empty: 'Δεν υπάρχουν εγγραφές ελέγχου.',
    when: 'Πότε',
    action: 'Ενέργεια',
    actorRole: 'Ρόλος χρήστη',
    target: 'Στόχος',
    rowsLabel: 'τις εγγραφές ελέγχου',
  },
};
